import { WsAutocompleteInput, BriefcaseBusinessIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const JobTitleFilter = ({ name, title, placeHolder, showAccordionIcon, icon }: WsFilterProps) => {
  const startIcon = icon || (showAccordionIcon && <BriefcaseBusinessIcon />);

  return (
    <WsAccordion title={title ?? 'Job Title'} {...(startIcon && { startIcon: startIcon })}>
      <WsAutocompleteInput
        name={name}
        options={[]}
        placeholder={placeHolder ?? `Job Title's`}
        freeSolo={true}
        multiple={true}
      />
    </WsAccordion>
  );
};
export default JobTitleFilter;
